module.exports = __webpack_public_path__ + "img/metro_marker.9dad650a.jpg";